var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"section docScroll",attrs:{"id":"sandbox"}},[_c('SectionColumn',{attrs:{"type":"left","title":"The Sandbox","content":_vm.contentLeftCol}}),_c('SectionColumn',{attrs:{"type":"right","content":_vm.contentRightCol}}),_c('SectionColumn',{attrs:{"type":"full","content":_vm.contentSandboxCol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }